<tec-modal
    [isVisible]="true"
    [title]="detail ? ('LEGAL_TERMS.FORM.EDIT' | translate) : ('LEGAL_TERMS.FORM.CREATE' | translate)"
    [buttonPrimaryLabel]="detail ? ('BUTTON.EDIT' | translate) : ('BUTTON.SAVE' | translate)"
    [buttonSecondaryLabel]="'BUTTON.CANCEL' | translate"
    (closeEvent)="closeModal($event)"
>
    <ng-container body [formGroup]="form">
        @if (errorMsg) {
        <tec-alert status="error" [msg]="errorMsg" (closeAlert)="errorMsg = ''" />
        }
        <div class="grid grid-e3">
            <tec-form-group
                class="legal_term-name"
                [label]="'LEGAL_TERMS.FORM.NAME' | translate"
                [errorMsg]="reactiveFormService.hasMsgError(form.get('custom_id'))"
            >
                <tec-input
                    formControlName="custom_id"
                    [hasError]="reactiveFormService.hasError(form.get('custom_id'))"
                />
            </tec-form-group>
            <tec-form-group
                [label]="'LEGAL_TERMS.FORM.REQUIRED' | translate"
                [errorMsg]="reactiveFormService.hasMsgError(form.get('required'))"
            >
                <tec-switch formControlName="required" />
            </tec-form-group>
        </div>

        <!-- HTML multidioma -->
        <tec-form-group
            [label]="'LEGAL_TERMS.FORM.HTML' | translate"
            [errorMsg]="reactiveFormService.hasMsgError(htmlControlForLang(selectedFormLang()))"
            [description]="'LEGAL_TERMS.FORM.HTML_DESCRIPTION' | translate"
        >
            <div id="legal-terms-html-locale-anchor">
                <tec-tabs [tabs]="formLangTabs" type="pills" (tabSelected)="onFormLangTab($event)" />
                @for (lang of allowedLanguages; track lang) {
                    @if (selectedFormLang() === lang) {
                        <tec-text-editor
                            [formControl]="htmlControlForLang(lang)"
                            [hasError]="reactiveFormService.hasError(htmlControlForLang(lang))"
                            [placeholder]="getHtmlPlaceholder()"
                            [showAlign]="false"
                            [showlist]="false"
                            [showAttachment]="false"
                            [showLink]="true"
                        />
                    }
                }
            </div>
        </tec-form-group>

        <!-- COMPANY -->
        @if (masterService.companies?.length > 1) {
        <tec-form-group
            [label]="'LEGAL_TERMS.FORM.COMPANY' | translate"
            [errorMsg]="reactiveFormService.hasMsgError(form.get('company_uuid'))"
        >
            <tec-select
                formControlName="company_uuid"
                [options]="masterService.companies"
                [hasError]="reactiveFormService.hasError(form.get('company_uuid'))"
                [placeholder]="'LEGAL_TERMS.FORM.COMPANY_PLACEHOLDER' | translate"
            />
        </tec-form-group>
        }
    </ng-container>
</tec-modal>
